import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "router";
import { Provider } from 'react-redux'
import { store } from "store";
import { PermissionProvider } from "react-permission-role";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const MarvarApp = () => {
  return (
    <>
      <PermissionProvider>
        <Provider store={store}>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </Provider>
      </PermissionProvider>
      <ToastContainer/>
    </>
  )
}

export {
  MarvarApp
}